import { ApolloClient, NormalizedCacheObject, useLazyQuery, useMutation } from '@apollo/client';
import {
  IsUsernameAvailableData,
  IsUsernameAvailableVars,
  RequestEmailUpdateData,
  RequestEmailUpdateVars
} from '../../membership/gql-types';

import ApolloClientService from '../services/ApolloClientService';
import Config from '../config';
import MembershipGraphQL from '../../membership/gql';
import { PublicGraphQL } from '../../membership/gql';

let membershipApolloClient: ApolloClient<NormalizedCacheObject> = null;
let publicMembershipClient: ApolloClient<NormalizedCacheObject> = null;

function useEmailUpdates() {
  if (!membershipApolloClient) {
    membershipApolloClient = ApolloClientService.create(Config.MEMBERSHIP_GQL);
  }

  if (!publicMembershipClient) {
    publicMembershipClient = ApolloClientService.create(
      Config.MEMBERSHIP_PUBLIC_GQL
    );
  }

  const [
    checkEmail,
    {
      called: checkEmailCalled,
      loading: checkEmailLoading,
      error: checkEmailError,
      data: checkEmailData
    }
  ] = useLazyQuery<IsUsernameAvailableData, IsUsernameAvailableVars>(
    PublicGraphQL.Query.IS_USERNAME_AVAILABLE,
    {
      client: publicMembershipClient,
      fetchPolicy: 'network-only'
    }
  );

  const [
    requestEmailUpdate,
    {
      called: requestEmailUpdateCalled,
      loading: requestEmailUpdateLoading,
      error: requestEmailUpdateError,
      data: requestEmailUpdateData
    }
  ] = useMutation<RequestEmailUpdateData, RequestEmailUpdateVars>(
    MembershipGraphQL.Mutation.REQUEST_EMAIL_UPDATE,
    {
      client: membershipApolloClient
    }
  );

  return {
    checkEmail: (tenant: string, login: string) =>
      checkEmail({ variables: { tenant, login } }),
    requestEmailUpdate: (
      locationOrigin: string,
      tenant: string,
      userkey: number,
      email: string,
      requireVerification: boolean
    ) =>
      requestEmailUpdate({
        variables: {
          locationOrigin,
          tenant,
          userkey,
          email,
          requireVerification
        }
      }),
    checkEmailCalled,
    checkEmailLoading,
    checkEmailError,
    checkEmailData,
    requestEmailUpdateCalled,
    requestEmailUpdateLoading,
    requestEmailUpdateError,
    requestEmailUpdateData: requestEmailUpdateData?.requestEmailUpdate
  };
}

export default useEmailUpdates;
